import { translationMixin } from '@tools/translation';
import { useFormGuidedSearchStore } from '@stores/useFormGuidedSearchStore';

export const guidedSearchMixin = {
  mixins: [ translationMixin ],
  computed: {
    store() {
      return useFormGuidedSearchStore();
    },
    actualStep() {
      return this.store.actualStep;
    },
    locationIsDisabled() {
      if (this.getLocationValues === null || !this.getLocationValues.locationChoice) {
        return true;
      }
      if (this.getLocationValues.locationChoice?.id === 0
        && (this.getLocationValues.locationTownInput === '' || this.getLocationValues.locationPostalCodeInput === '')) {
        return true;
      }

      if (this.getLocationValues.locationChoice?.id === 0 && (this.isLocationTownInputInvalid || this.isPostalCodeInvalid)) {
        return true;
      }
      return false;
    },
    getLocationValues() {
      return this.store.stepValues.location;
    },
    isPostalCodeInvalid() {
      const exp = /^\w{1,5}$/;
      return !exp.test(this.getLocationValues.locationPostalCodeInput);
    },
    isLocationTownInputInvalid() {
      const exp = /^[^\d]+$/;
      return !this.getLocationValues.locationTownInput || !exp.test(this.getLocationValues.locationTownInput);
    },
    capacityIsDisabled() {
      return !this.store.stepValues.capacity;
    },
    submitIsDisabled() {
      if (this.store.actualStep === 0) {
        return this.locationIsDisabled;
      }
      if (this.store.actualStep === 1) {
        return this.capacityIsDisabled;
      }
      if (this.store.actualStep === 2 && this.store.stepValues.installationMonth === null) {
        return true;
      }
      if (this.store.actualStep === 3 && this.store.stepValues.duration === null) {
        return true;
      }
      if (this.isStepBudgetDisabled || this.isStepBudgetMaxAmountExceeded) {
        return true;
      }
      if (this.isOrganizationDisabled) {
        return true;
      }
      if (this.isStepUserDisabled) {
        return true;
      }
      return false;
    },
    isStepBudgetDisabled() {
      const { budget } = this.store.stepValues;
      return this.store.actualStep === 4 && !budget.isUnknown && !budget.price;
    },
    isStepBudgetMaxAmountExceeded() {
      const { budget } = this.store.stepValues;
      return parseInt(budget.price, 10) > 99999999;
    },
    isOrganizationDisabled() {
      const { organization } = this.store.stepValues;
      return this.store.actualStep === 5 && (!organization || organization.trim() === '');
    },
    getUserData() {
      return this.store.stepValues.user;
    },
    isStepUserDisabled() {
      return this.store.actualStep === 5 && (this.isUserNameInvalid || !this.getUserData.phoneNumberIsValid || !this.isUserEmailValid);
    },
    isUserNameInvalid() {
      const nameRegex = /^[^\d]+$/;
      return this.store.actualStep === 5 && (!this.getUserData.fullName || this.getUserData.fullName.trim() === '' || !nameRegex.test(this.getUserData.fullName));
    },
    isUserEmailValid() {
      const emailRegex = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/i;
      return emailRegex.test(this.getUserData.email);
    },
  },
  methods: {
    changeActualStep(step) {
      this.store.changeActualStep(step);
    },
    waitTime(time) {
      // eslint-disable-next-line no-promise-executor-return
      return new Promise((resolve) => setTimeout(resolve, time));
    },
  },
};
